import React, { Component } from "react";
import PropTypes from "prop-types";
import { VelocityTransitionGroup } from "velocity-react";
import VideoInfoBox from "../VideoInfoBox";
import emptyVideoBox from "../../assets/imgs/Highlight_skelleton-12.svg";
import upArrow from "../../assets/imgs/up-arrow.svg";

require("velocity-animate");
require("velocity-animate/velocity.ui");

class VideosGrid extends Component {
  handleSelectAll = () => {
    // this.setState(prevState => ({ selectAll: !prevState.selectAll }));
    if (this.props.onSelectAll) {
      this.props.onSelectAll(this.props.selectedVideos.length < 1);
    }
  };

  render() {
    const {
      videos,
      selectedVideos,
      onClick,
      onAdd,
      title,
      gridStyle,
      videoBoxStyle,
      children,
      hasSelectAll,
      hasHeader,
      hasClipBedge,
      hasAddButton
    } = this.props;

    const isVideoSelected = video => {
      if (selectedVideos) {
        const filterArray = selectedVideos.filter(
          selectedVideo => selectedVideo.id === video.id
        );
        return filterArray.length > 0;
      }
      return false;
    };

    const emptyVideo = (
      <img
        style={{ height: "230px", padding: "10px 20px 0 20px" }}
        src={emptyVideoBox}
        alt="empty-video"
      />
    );

    //hasClipBedge is flag to know which screen the grid is

    const emptyGrid = hasClipBedge
      ? Array(16).fill(emptyVideo)
      : Array(8).fill(emptyVideo);

    const videosList =
      videos && videos.length > 0
        ? videos.map(video => (
            <VideoInfoBox
              key={video.id}
              isSelected={isVideoSelected(video)}
              onAdd={onAdd}
              onClick={onClick}
              style={videoBoxStyle}
              video={video}
              hasAddButton={hasAddButton}
              hasClipBedge={hasClipBedge}
            />
          ))
        : emptyGrid;

    return (
      <div className="videosGrid__container">
        {hasHeader && (
          <span className="videosGrid__total-panel">
            <span className="videosGrid__total-panel--highlights-number">
              {videos && videos.length}
            </span>
            {title}
            <span
              style={{
                position: "absolute",
                right: "70px",
                cursor: "pointer",
                fontSize: "14px"
              }}
              onClick={this.handleSelectAll}
            >
              {hasSelectAll
                ? this.props.selectedVideos.length > 0
                  ? "Deselect All"
                  : "Select All"
                : null /* eslint-disable-line */}
            </span>
            {children}
          </span>
        )}

        <VelocityTransitionGroup
          enter={{
            animation: "transition.slideLeftBigIn"
          }}
          leave={{
            animation: "transition.slideDownBigOut",
            duration: "200",
            delay: "500"
          }}
          className="videosGrid__grid"
          style={gridStyle}
        >
          {videosList}
        </VelocityTransitionGroup>
        {videosList === emptyGrid ? (
          !hasClipBedge ? (
            <div className="videosGrid__empty-title">
              <img
                style={{ width: "50px", marginBottom: "20px" }}
                src={upArrow}
                alt="empty-grid"
              />
              <span>
                Start <span style={{ color: "red" }}>Recording</span>{" "}
                Highlights!
              </span>
            </div>
          ) : (
            <div className="videosGrid__empty-title">
              <span>
                There Is No <span style={{ color: "#16c4ab" }}>Comments</span>{" "}
                For This Game Yet !
              </span>
            </div>
          )
        ) : null}
      </div>
    );
  }
}

VideosGrid.propTypes = {
  children: PropTypes.node.isRequired,
  /** custom style to pass to videos grid, such as number of columns   */
  gridStyle: PropTypes.object,
  /** show add button on the videobox */
  hasAddButton: PropTypes.bool,
  hasClipBedge: PropTypes.bool,
  /** show total videos title*/
  hasHeader: PropTypes.bool,
  /** show select all button */
  hasSelectAll: PropTypes.bool,
  /** function to call when click on the ADD button in video box   */
  onAdd: PropTypes.func,
  /** function to call when click on video box in the grid */
  onClick: PropTypes.func,
  /** on selectAll click */
  onSelectAll: PropTypes.func,
  /** array of selected videos to show on the grid */
  selectedVideos: PropTypes.array.isRequired,
  /** title to show above the grid near the video counter */
  title: PropTypes.string,
  /** custom style to pass to video box */
  videoBoxStyle: PropTypes.object,
  /** array of videos to show on the grid */
  videos: PropTypes.array.isRequired
};
VideosGrid.defaultProps = {
  gridStyle: {},
  hasAddButton: true,
  hasClipBedge: false,
  hasHeader: true,
  hasSelectAll: true,
  onAdd: () => {},
  onClick: () => {},
  onSelectAll: () => {},
  title: "Recorded Highlights",
  videoBoxStyle: {}
};

export default VideosGrid;
